import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ProgressTracker } from "@atlaskit/progress-tracker";
import { getCurrentWizardPage } from "./tutorials/wizardRegistry";
import { addProgress } from "./utils/wizardFunctions";
import SectionMessage from "@atlaskit/section-message";

const WizardPage = () => {
  const [items, setItems] = useState([]);
  const currentWizard = useSelector((state) => state.wizard.currentWizard);
  const currentPage = useSelector((state) => state.wizard.currentPage);
  const errorMessage = useSelector((state) => state.wizard.errorMessage);

  useEffect(() => {
    //console.log("WizardPage");
    //if (currentWizard && currentWizard.pages !== items) {
    const progressedItems = addProgress(currentWizard.pages, currentPage);
    setItems(progressedItems);
    //}
  }, [currentWizard, currentPage]);

  return (
    <>
      {items && items.length > 0 && (
        <ProgressTracker items={items} spacing="compact" />
      )}
      {getCurrentWizardPage(currentWizard.id, currentPage)}
      <br/>
      {errorMessage && (
        <SectionMessage
          title={errorMessage}
          appearance="warning"
        ></SectionMessage>
      )}
    </>
  );
};

export default WizardPage;
